export enum FormSaveStatusActionType {
    SetSavingStatus = "SET_SAVING_STATUS",
}

export type FormSavingStatus = "saving" | "success" | "error" | "unsavedChanges";

export interface FormSaveStatusAction {
    type: FormSaveStatusActionType.SetSavingStatus;
    payload: { status: FormSavingStatus };
}
